import React from 'react';
import { useSelector } from 'react-redux';
import { Form } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';
import { setShowAssetSelection } from 'packages/store/creativeEditor/creativeEditor.actions';
import { showAssetSelectionSelector } from 'packages/store/creativeEditor/creativeEditor.selectors';
import { getElementPropertiesFromSource } from '~/common/editor/helpers';
import BrowseButton from '../../../FormComponents/BrowseButton';
import { ContentType } from '../../../FormComponents/BrowseButton/types';

const BrowseVideo = ({ creativeModel, selectedElement, frameRate, disabled }) => {
    const { translate } = useTranslate();
    const showAssetSelection = useSelector(showAssetSelectionSelector);
    const { fileName, locked, duration, dimension, src, srcId, id: elementId, isAlpha } = selectedElement;

    const handleSelectSource = (selectedSource) => {
        const resetDefault = srcId !== selectedSource.id;

        const params = getElementPropertiesFromSource(selectedElement, 'VIDEO', selectedSource);

        if (resetDefault) {
            // Reset to default values
            if (params.contentTransform) {
                const { width: naturalWidth, height: naturalHeight } = params.naturalDimension;
                const { width, height } = dimension;
                const scale = +Math.min(width / naturalWidth, height / naturalHeight, 1).toFixed(2);

                params.contentTransform.scale = scale;
                params.contentTransform.horizontalOffset = Math.round(width / 2 - (naturalWidth * scale) / 2);
                params.contentTransform.verticalOffset = Math.round(height / 2 - (naturalHeight * scale) / 2);
            } else {
                const { type } = selectedElement.contentTransform;
                params.contentTransform = {
                    verticalAlignment: 0,
                    horizontalAlignment: 0,
                    type,
                };
            }
        }

        creativeModel.updateElement(elementId, params);
    };

    return (
        <Form.Group>
            {src && <Form.Label>{translate('editor.sidebar.shots.video.tabs.content')}</Form.Label>}
            <BrowseButton
                type={ContentType.VIDEO}
                frameRate={frameRate}
                fileName={fileName}
                selectedObject={{ element: selectedElement, duration }}
                disabled={locked || disabled}
                handleSelectSource={handleSelectSource}
                show={showAssetSelection}
                setShowAssetSelection={setShowAssetSelection}
                mediaSrc={src}
                isAlpha={isAlpha}
                testId="shots_video_asset"
                resizableRange
                isEditorPage
            />
        </Form.Group>
    );
};

export default BrowseVideo;
